import React from "react";

function Project() {
  return (
    <div>
      <div className="project-item">
        <div className="project-list-header">Lead Product Designer</div>
        <div className="project-paragraph">
          Lorem maximus dictumst elementum efficitur lobortis per egestas dis
          tincidunt nam non netus venenatis amet dolor dapibus donec justo
          augue.
        </div>
      </div>
    </div>
  );
}

export default Project;
